// LOAD-BEARING SIDE-EFFECT IMPORT — do not delete as "unused". See the
// `src/hooks/query/integrations/useQueryEhrLaunchPastNotes.ts` delegate on this
// door for the measurement: this specifier used to warm up the Rematch model
// cluster on the way to the api hub.
import '@/pages/api/scribeAPIV2';

import { trackIntegrationUpdated } from '@/lib/analytics/integrations/ehr-events';
import { GET_USER_EHR } from '@heidi/integrations/ehr/contracts';
import { useMutateUpdateIntegrationEhrLaunch as useMutateUpdateIntegrationEhrLaunchCore } from '@heidi/integrations/ehr/data';
import { type EHRProvider } from '@heidi/schema/ml-scribe';

/**
 * Delegate. The write — request, both invalidations, the error logging and the
 * success toast (now `meta`) — lives at `@heidi/integrations/ehr/data`. Two
 * things stay here, and they are different kinds of thing.
 *
 * GET_USER_EHR now lives in ehr contracts; the delegate still passes userEhrQueryKey. The analytics emit is an app REACTION and stays for
 * a different reason — the package zone takes no analytics dependency at all.
 * What changed is HOW it is emitted: the `dispatch.analyticsScribe` bus call is
 * now the plain `trackIntegrationUpdated` emitter, so this delegate holds no
 * Rematch leg. It is still a bodied delegate rather than a re-export shim
 * because the key and the reaction both have to be supplied here.
 *
 * Signature unchanged: callers still invoke this with no arguments.
 */
export function useMutateUpdateIntegrationEhrLaunch() {
  return useMutateUpdateIntegrationEhrLaunchCore({
    userEhrQueryKey: [GET_USER_EHR],
    onIntegrationUpdated: (provider: EHRProvider) => {
      trackIntegrationUpdated({ integration_type: provider });
    },
  });
}
